export const SUCCESS_CODE = 200;
export const ERROR_STATUS_KEY = "ERROR";
export const INVALID_USER_EMAIL = "101001";
export const MAX_RESEND_PASSWORD_RETRIES_EXCEED = "101004";
export const MAX_NUMBER_OF_RETRIES = "900001";
export const ACTIVATION_LINK_EXPIRED = "900004";
export const INVALID_USER_EMAIL_OR_STATUS = "101007";
export const NOT_FOUND_USER_EMAIL = "101008";
